import { FullPageError } from '@/components/full-page-state';

/** A render error in a route: say so plainly and offer a reload. */
export function RouteErrorPage() {
  return (
    <FullPageError
      title="Something broke on this page"
      message="Reload the page. If it keeps happening, write to info@macswarm.com."
      onRetry={() => window.location.reload()}
    />
  );
}
